import React, { useEffect, useState } from 'react';
import { Alert, Button, Spinner, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { platformAPI } from '../../../services/platformAPI';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { AdminPlainBar, AdminRowDelete, useAdminRecordDelete } from '../../../components/workspace/useAdminRecordDelete';
import { useMasterRevision } from '../../../components/workspace/useMasterRevision';

const DecisionProfilesPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  useDocumentTitle('Go / No-Go profiles');
  const load = () => platformAPI.listDecisionProfiles()
    .then((response) => setRows(response.data?.data?.profiles || []))
    .catch((err) => setError(err.response?.data?.message || 'Unable to load profiles'));
  useEffect(() => { load(); }, []);
  const admin = useAdminRecordDelete({
    entity: 'decisionProfile',
    noun: 'profile',
    plural: 'profiles',
    reload: load,
    label: (row) => row.name
  });
  const revision = useMasterRevision({ entity: 'decisionProfile' });
  return (
    <div className="cust-page">
      <button type="button" className="cust-page__back" onClick={() => navigate('/apps/tender/masters')}><BiArrowBack /> Masters</button>
      <h1 className="h4">Go / No-Go profiles</h1>
      <p className="text-muted">A new save creates the next version. Existing tender assessments keep the snapshot they were scored against. The sample profile is a demonstration default, not a confirmed Dhruv policy.</p>
      {error ? <Alert variant="warning">{error}</Alert> : null}
      {admin.notice}
      <AdminPlainBar admin={admin} rows={rows} />
      {!rows.length && !error ? <Spinner animation="border" size="sm" /> : null}
      {rows.map((row) => (
        <section key={row._id} className="mb-3">
          <h2 className="h6">{row.name} · version {row.version} · revision {row.revision || 1}{row.isSample ? ' · sample' : ''}{row.isActive ? '' : <span className="cust-status cust-status--inactive"> · Inactive</span>} <Button size="sm" variant="link" onClick={() => revision.open(row)}>Revision info</Button> <AdminRowDelete admin={admin} id={row._id} label={row.name} /></h2>
          <p className="small">Go at {row.goAt}. Conditional go at {row.conditionalAt}.</p>
          <Table size="sm">
            <thead><tr><th>Criterion</th><th>Weight</th><th>Maximum</th></tr></thead>
            <tbody>{(row.criteria || []).map((item) => <tr key={item.code}><td>{item.name}</td><td>{item.weight}%</td><td>{item.maxScore}</td></tr>)}</tbody>
          </Table>
          <p className="small">Mandatory gates: {(row.gates || []).map((gate) => gate.label).join('; ') || 'None'}</p>
        </section>
      ))}
      {admin.modal}
      {revision.modals}
    </div>
  );
};

export default DecisionProfilesPage;
